import React from 'react';
import { Heart, Dumbbell, Footprints, Zap } from 'lucide-react';
export function FitnessWhyMartialArts() {
  return <section className="py-24 bg-paper border-b border-subtle-gray" data-id="element-1472">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1473">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1474">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1475">
            Why Martial Arts Work for Fitness
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1476">
            Martial arts provide a comprehensive, full-body workout that
            challenges your cardiovascular system, builds functional strength,
            and improves flexibility and balance—all while relieving stress.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1477">
          {[{
          icon: Heart,
          title: 'Cardiovascular Health',
          desc: 'High-intensity drills and continuous movement keep your heart rate up, burning calories and building endurance.'
        }, {
          icon: Dumbbell,
          title: 'Functional Strength',
          desc: 'Striking, blocking, and stance work build lean muscle and core stability without heavy weights.'
        }, {
          icon: Footprints,
          title: 'Flexibility & Balance',
          desc: 'Dynamic stretching and kicking techniques naturally improve your range of motion and body control.'
        }, {
          icon: Zap,
          title: 'Stress Relief',
          desc: 'Physical exertion combined with mental focus provides a powerful outlet for daily stress and anxiety.'
        }].map((benefit, idx) => <div key={idx} className="bg-off-white p-8 rounded-2xl border border-subtle-gray text-center" data-id="element-1478">
              <div className="w-16 h-16 bg-storm-red/10 rounded-full flex items-center justify-center mx-auto mb-6 text-storm-red" data-id="element-1479">
                <benefit.icon className="w-8 h-8" data-id="element-1480" />
              </div>
              <h3 className="text-xl text-ink mb-3" data-id="element-1481">{benefit.title}</h3>
              <p className="text-gray-warm" data-id="element-1482">{benefit.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}